import React from 'react';

export type ITable = {
    __typename?: string,
    id?: string,
    table: {
        columns: string[],
        data: unknown[]
    }
};

export default function Table(props: ITable) {
    return (
        <div className="relative overflow-x-auto rounded">
            <table className="w-full text-sm text-left text-gray-500 ">
                <thead className="text-xs text-gray-700 uppercase bg-purple-tint-light">
                <tr>
                    {props.table.columns.map((c, i) => (
                        <th scope="col" className="px-6 py-3 text-purple" key={`table-header-row-${i}`}>{c}</th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {props.table.data.map((d, i) => (
                    <tr key={`data-row-${i}`} className="bg-white border-b">
                        {Object.keys(d).map((key, value) => {
                            return (
                                <td key={key} scope="row" className="px-6 py-4 font-medium text-gray-900">
                                    <span className={"inline-block"}>{d[key]}</span>
                                </td>
                            );
                        })}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}